export const ratingIconConstants = {
  RATING_ICONS: {
    1: {
      key: 'very-sad',
      name: '悪い',
    },
    2: {
      key: 'sad',
      name: 'よくない',
    },
    3: {
      key: 'neutral',
      name: 'ふつう',
    },
    4: {
      key: 'fine',
      name: 'よい',
    },
    5: {
      key: 'very-fine',
      name: 'とても良い',
    },
  },
} as const
